import { Empty, Table, Tag } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStores } from "../../../../store";
import { formatNumber, __ } from "../../../../utils";
const {
  Column
} = Table;
const AccountAffiliatePayoutsTable = observer(() => {
  const {
    accountStore
  } = useStores();
  const {
    session: {
      affiliate
    }
  } = accountStore;
  const {
    lang
  } = document.documentElement;
  const {
    busyPayouts: busy,
    payouts,
    affiliate: {
      payoutThreshold
    }
  } = affiliate;
  useEffect(() => {
    affiliate.fetchPayouts();
  }, [affiliate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, __(`We pay your commissions always on the 15th of the following month in which they were earned, if it is above the threshold of %d EUR (can be changed in "Invoice & payment data"). Below you will find receipts dor all payouts in the last 24 month.`, payoutThreshold)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("No payment has been instructed yet.")
      })
    },
    loading: busy,
    pagination: false,
    dataSource: Array.from(payouts.values()),
    rowKey: row => row.id,
    size: "small"
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Invoice no."),
    dataIndex: "id",
    key: "id",
    render: (_, _ref) => {
      let {
        id
      } = _ref;
      return `#${id}`;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Date"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_, _ref2) => {
      let {
        createdAt
      } = _ref2;
      return new Date(createdAt).toLocaleDateString(lang);
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Receipt(s)"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (_, _ref3) => {
      let {
        receipts
      } = _ref3;
      return receipts.map((_ref4, i) => {
        let {
          downloadUrl
        } = _ref4;
        return /*#__PURE__*/React.createElement(Tag, {
          onClick: () => window.open(downloadUrl, "_blank"),
          key: i
        }, __("Download"), receipts.length > 1 ? ` (#${i + 1})` : "");
      });
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Total"),
    dataIndex: "total",
    key: "total",
    align: "right",
    render: (_, _ref5) => {
      let {
        netTotal,
        vatTotal
      } = _ref5;
      return /*#__PURE__*/React.createElement(React.Fragment, null, formatNumber(netTotal, 2), " EUR", vatTotal > 0 ? ` (plus ${formatNumber(vatTotal, 2)} EUR VAT)` : ``);
    }
  })));
});
export { AccountAffiliatePayoutsTable };